import React, { Dispatch } from 'react';
import { useParams } from 'react-router-dom';
import { ContentLayout } from '../../_parts/ContentLayout';
import Tabs from './Tabs';
import Documents from '../../_parts/Documents';
import { useSelector, useDispatch } from 'react-redux';
import { IAppReduxStore } from '../../../../../redux/store';
import {
    getReleaseDocuments,
    getReleaseTabs,
    removeDocumentFromInitialWorkflow,
} from '../../../../../redux/project/sliceProjectWorkflow';
import { SelectWorkflow } from './SelectWorkflow';
import { StateChangedArgumentsInitialRelease } from '../InitialReleaseDialog/InitialReleaseDialog';

export default ({ mainState, getStateChanged, hasError }: IInitialReleaseContentProps) => {
    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    const { selectedReleaseTab: selectedTab, isLoadingData } = useSelector(
        (_store: IAppReduxStore) => _store.projectWorkflow,
    );
    const tabs = useSelector(getReleaseTabs);
    const documents = useSelector(getReleaseDocuments);

    const { areaName } = useParams();

    /**
     * Removes documents from workflow.
     * @param documentUniId Document Universal ID.
     */
    const removeDocument = documentUniId => {
        const removeDocumentProps = { documentUniId, selectedTab, areaName };
        dispatch(removeDocumentFromInitialWorkflow(removeDocumentProps));
    };

    return (
        <ContentLayout
            loading={isLoadingData}
            tabs={<Tabs />}
            documentSelection={<Documents documents={documents} removeDocument={removeDocument} />}
            main={
                documents.length > 0 && (
                    <SelectWorkflow
                        getStateChanged={getStateChanged}
                        hasError={hasError}
                        selected={mainState}
                        parentValue={tabs[selectedTab].key}
                    />
                )
            }
        />
    );
};

interface IInitialReleaseContentProps {
    mainState: {
        [key: string]: string;
    };
    getStateChanged: (arg: StateChangedArgumentsInitialRelease) => void;
    hasError: boolean;
}
